import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './ProjectSelection.css';
import { useConcerns } from '../../contexts/ConcernContext';
import { api } from '../../utils/authApi';

function ProjectSelection() {
  const navigate = useNavigate();
  const [projects, setProjects] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const { changeProject } = useConcerns();
  
  useEffect(() => {
    const fetchProjects = async () => {
      try {
        // Get user from localStorage
        const userInfoString = localStorage.getItem('user_info');
        
        if (!userInfoString) {
          setError('User information not found');
          setLoading(false);
          return;
        }

        const userInfo = JSON.parse(userInfoString);
        const userID = userInfo.user_id;

        // Fetch projects from API with JWT token
        const response = await api.get(`/projects/${userID}`);
        const data = await response.json();
        
        console.log('API Response:', data);
        
        // Transform the array data into objects
        const transformedProjects = data.projects.map(project => ({
          id: project[0],                    // Project ID
          user_id: project[1],               // User ID
          location: project[2],              // Location
          email: project[3],                 // Email
          name: project[4],                  // Project Name
          created_at: project[5],            // Created timestamp
          updated_at: project[6]             // Updated timestamp
        }));

        console.log('Transformed Projects:', transformedProjects);
        setProjects(transformedProjects);
        setLoading(false);
      } catch (error) {
        console.error('Error:', error);
        setError('Failed to load projects');
        setLoading(false);
      }
    };

    fetchProjects();
  }, [navigate]);

  const handleProjectSelect = (projectId, projectLocation) => {
    localStorage.setItem('selectedProject', JSON.stringify({
      "projectID": projectId,
      "projectLocation": projectLocation
    }))
    
    // Trigger refetch in context
    changeProject(projectId);
    navigate(`/client-dashboard`);
  };

  if (loading) {
    return (
      <div className="project-selection-container">
        <p>Loading projects...</p>
      </div>
    );
  }

  if (error) {
    return (
      <div className="project-selection-container">
        <div className="error-message">{error}</div>
      </div>
    );
  }

  if (projects.length === 0) {
    return (
      <div className="project-selection-container">
        <div className="no-projects">
          <h2>No Projects Found</h2>
          <p>You don't have any projects yet.</p>
        </div>
      </div>
    );
  }

  return (
    <div className="project-selection-container">
      <h1>Select a Project</h1>
      <p className="subtitle">Choose which project you'd like to view</p>

      <div className="projects-grid">
        {projects.map((project) => (
          <div
            key={project.id}
            className="project-card"
            onClick={() => handleProjectSelect(project.id, project.location)}
          >
            <div className="project-card-header">
              <h3>{project.name}</h3>
            </div>
            <div className="project-card-body">
              <p className="project-location">
                <strong>Location:</strong> {project.location}
              </p>
              <p className="project-email">
                <strong>Contact:</strong> {project.email}
              </p>
              <p className="project-date">
                <small>Created: {new Date(project.created_at).toLocaleDateString()}</small>
              </p>
            </div>
            <div className="project-card-footer">
              <button className="view-project-btn">View Concerns →</button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default ProjectSelection;